const list = {
  development1: { 
    API_BASE_URL: '//sczd.pointlinkprox.com',
    SIP_BASE_URL: '//sczd.pointlinkprox.com/sipphone',
    SCMCC_HOST: '//sczd.pointlinkprox.com',
    SCMD_API_BASE: '//sczd.pointlinkprox.com',
    WS_HOST: 'wss://sczd.pointlinkprox.com',
    MON_HOST: 'https://qll.pointlinkprox.com:8445'
  },
  development2: {
    API_BASE_URL: '//sczd.pointlinkprox.com',
    SIP_BASE_URL: '//sczd.pointlinkprox.com/sipphone',
    SCMCC_HOST: '//sczd.pointlinkprox.com',
    SCMD_API_BASE: '//sczd.pointlinkprox.com',
    WS_HOST: 'wss://sczd.pointlinkprox.com',
    MON_HOST: 'https://qll.pointlinkprox.com:8445',
    CONF_HOST: 'https://localhost:8010/scconf_ui.umd.min.js',
    MODULE_HOST: '//sczd.pointlinkprox.com/'
  },
  development: {
    API_BASE_URL: '//sczd.pointlinkprox.com',
    SIP_BASE_URL: '//sczd.pointlinkprox.com/sipphone',
    SCMCC_HOST: '//sczd.pointlinkprox.com',
    SCMD_API_BASE: '//sczd.pointlinkprox.com',
    WS_HOST: 'wss://sczd.pointlinkprox.com',
    isTEN: true,
    MON_HOST: 'https://qll.pointlinkprox.com:8445',
    CONF_HOST: '//sczd.pointlinkprox.com/scconf_ui.umd.min.js',
  },
  production: {
    production: {
      API_BASE_URL: '//sczd.pointlinkprox.com',
      SIP_BASE_URL: 'https://newim.xxx.xx/sipdownload',
      SCMCC_HOST: '//sczd.pointlinkprox.com',
      WS_HOST: 'wss://sczd.pointlinkprox.com',
      SCMD_API_BASE: '//sczd.pointlinkprox.com/',
      WEBCHAT_HOST: 'https://tydh.cmcc-cs.cn:31213/webchat',
      MON_HOST: 'https://qll.pointlinkprox.com:8445'
    },
    syh_znwh: {
      API_BASE_URL: '//sczd.pointlinkprox.com',
      SIP_BASE_URL: '//sczd.pointlinkprox.com/sipphone',
      SCMCC_HOST: '//sczd.pointlinkprox.com',
      SCMD_API_BASE: '//sczd.pointlinkprox.com',
      WS_HOST: 'wss://sczd.pointlinkprox.com',
      WEBCHAT_HOST: 'https://tydh.cmcc-cs.cn:31213/webchat',
      MON_HOST: 'https://qll.pointlinkprox.com:8445'
    },
    zybproduction: {
      API_BASE_URL: '//www.xxx.xx',
      SIP_BASE_URL: 'https://newim.xxx.xx/sipdownload',
      SCMCC_HOST: '//www.xxx.xx',
      SCMD_API_BASE: '//www.xxx.xx',
      WS_HOST: 'wss://www.xxx.xx',
      WEBCHAT_HOST: 'https://tydh.cmcc-cs.cn:31213/webchat',
      MON_HOST: 'https://qll.pointlinkprox.com:8445'
    },
    zybproduction_gray: {
      API_BASE_URL: '//znwh.xxx.xx',
      SIP_BASE_URL: 'https://newim.xxx.xx/sipdownload',
      SCMCC_HOST: '//znwh.xxx.xx',
      SCMD_API_BASE: '//znwh.xxx.xx',
      WS_HOST: 'wss://znwh.xxx.xx',
      WEBCHAT_HOST: 'https://tydh.cmcc-cs.cn:31213/webchat',
      MON_HOST: 'https://qll.pointlinkprox.com:8445'
    },
    zybproduction_home: {
      API_BASE_URL: '//home.xxx.xx:22011',
      SIP_BASE_URL: 'https://newim.xxx.xx/sipdownload',
      SCMCC_HOST: '//home.xxx.xx:22011',
      SCMD_API_BASE: '//home.xxx.xx:22011',
      WS_HOST: 'wss://home.xxx.xx:22011',
      WEBCHAT_HOST: 'https://tydh.cmcc-cs.cn:31213/webchat',
      MON_HOST: 'https://qll.pointlinkprox.com:8445'
    },
    new_test: {
      API_BASE_URL: '//sczd.pointlinkprox.com',
      SIP_BASE_URL: '//sczd.pointlinkprox.com/sipphone',
      SCMCC_HOST: '//sczd.pointlinkprox.com',
      SCMD_API_BASE: '//sczd.pointlinkprox.com',
      WS_HOST: 'wss://sczd.pointlinkprox.com',
      isTEN: true,
      MON_HOST: 'https://qll.pointlinkprox.com:8445',
      CONF_HOST: '//sczd.pointlinkprox.com/scconf_ui.umd.min.js',
    },
    lydev: {
      API_BASE_URL: '//sczd.pointlinkprox.com',
      SIP_BASE_URL: '//sczd.pointlinkprox.com/sipphone',
      SCMCC_HOST: '//sczd.pointlinkprox.com',
      SCMD_API_BASE: '//sczd.pointlinkprox.com',
      WS_HOST: 'wss://sczd.pointlinkprox.com',
      isTEN: true,
      MON_HOST: 'https://qll.pointlinkprox.com:8445',
      CONF_HOST: '//localhost:8010/scconf_ui.umd.min.js',
    },
    hatest: {
      API_BASE_URL: '//sczd.pointlinkprox.com',
      SIP_BASE_URL: '//sczd.pointlinkprox.com/sipphone',
      SCMCC_HOST: '//sczd.pointlinkprox.com',
      SCMD_API_BASE: '//sczd.pointlinkprox.com',
      WS_HOST: 'ws://sczd.pointlinkprox.com',
      MON_HOST: 'https://qll.pointlinkprox.com:8445'
    },
    hatest_docker: {
      API_BASE_URL: '//sczd.pointlinkprox.com',
      SIP_BASE_URL: '//sczd.pointlinkprox.com/sipphone',
      SCMCC_HOST: '//sczd.pointlinkprox.com',
      SCMD_API_BASE: '//sczd.pointlinkprox.com',
      WS_HOST: 'ws://sczd.pointlinkprox.com',
      MON_HOST: 'https://qll.pointlinkprox.com:8445'
    },
    zybhatest_docker: {
      API_BASE_URL: '//sczd.pointlinkprox.com',
      SIP_BASE_URL: '//sczd.pointlinkprox.com/sipphone',
      SCMCC_HOST: '//sczd.pointlinkprox.com',
      SCMD_API_BASE: '//sczd.pointlinkprox.com',
      WS_HOST: 'wss://sczd.pointlinkprox.com',
      MON_HOST: 'https://qll.pointlinkprox.com:8445'
    }
  }
}
// 通过构建环境来获取不同常量对象
let envConst = process.env.VUE_APP_ENV
  ? list[process.env.NODE_ENV][process.env.VUE_APP_ENV]
  : list[process.env.NODE_ENV]
export default envConst
